<div class="card-holder">
    <p class="card-holder-label">Valor:</p>
    <p class="card-holder-value">{{currency}}
        <input class="salary__input-value" data-test="salaryValue" [ngModel]="value || 0 | number:'1.2-2'" [type]="show ? 'text' : 'password'" disabled>
    </p>
    <button type="button" class="salary__show" data-test="btnShowSalaryValue" (click)="this.show = !this.show;">
        <span *ngIf="!this.show">Mostrar valor</span>
        <span *ngIf="this.show">Ocultar valor</span>
    </button>
    <up-ui-copy-button [newBrand]="true" data-test="btnCopySalary" [label]="value"></up-ui-copy-button>
</div>
